import React, { Component } from 'react';
import { ReactSVG } from 'react-svg';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Layout, Icon } from 'antd';
import MenuItems from './MenuItems';
import { DeleteUser } from '../../../redux/User/user.actions';
import { MenuToggle } from "../../../redux/Menu/menu.actions";
import { withRouter } from 'react-router-dom';
import {
  StyledMenuItem,
  StyledNavLink,
  StyledSider,
  StyledContent,
  TransitionLayout,
  MenuSVG,
  StyledSubMenu,
  StyledMenu
} from './LayoutStyles';
import HeaderComponent from './HeaderComponent';

class ResponsiveSider extends Component {
  componentDidMount = () => {
    this.mounted = true;
  };

  logOut = () => {
    const { DeleteUser, history } = this.props;
    localStorage.clear();
    DeleteUser();
    history.push('/login');
  };

  renderMenuList = (item, index) => {
    const { user } = this.props;
    if (!user || user.role > item.permission_type) return null;
    switch (item.type) {
      case 'menu':
        return (
          <StyledMenuItem key={index} onClick={() => this.openSider()}>
            <StyledNavLink
              to={item.to}
              exact={item.exact}
              activeClassName='activated'
            >
              {item.external_icon ? (
                <MenuSVG className='anticon' size={item.size}>
                  <ReactSVG path={item.icon} />
                </MenuSVG>
              ) : (
                <Icon
                  style={{ fontSize: item.size ? item.size : '20px' }}
                  type={item.icon}
                />
              )}
              <span>{item.name}</span>
            </StyledNavLink>
          </StyledMenuItem>
        );
      case 'submenu':
        return (
          <StyledSubMenu
            key={index}
            title={
              <>
                {item.external_icon ? (
                  <MenuSVG className='anticon' size={item.size}>
                    <ReactSVG path={item.icon} />
                  </MenuSVG>
                ) : (
                  <Icon
                    style={{ fontSize: item.size ? item.size : '20px' }}
                    type={item.icon}
                  />
                )}
                <span>{item.name}</span>
              </>
            }
          >
            {item.to.map(this.renderMenuList)}
          </StyledSubMenu>
        );
      default:
        return [];
    }
  };

  openSider = () => {
    const { MenuToggle } = this.props;

    MenuToggle(false);
  }

  handleSider = () => {
    const { menuOpen, MenuToggle } = this.props;

    MenuToggle(!menuOpen);
  }

  render() {
    const { menuOpen } = this.props;

    return (
      <Layout>
        <HeaderComponent />
        <div style={{ width: '100%' }}>
          <StyledSider
            className='no-print'
            collapsible
            collapsed={menuOpen}
            onCollapse={this.handleSider}
          > 
            <StyledMenu mode='inline'>
              {MenuItems.map(this.renderMenuList)}
              <StyledMenuItem key={10} onClick={this.logOut}>
                <Icon style={{ fontSize: '20px' }} type={'logout'} />
                <span>{'Logout'}</span>
              </StyledMenuItem>
            </StyledMenu>
          </StyledSider>
          <TransitionLayout collapsed={menuOpen}>
            <StyledContent>{this.props.children}</StyledContent>
          </TransitionLayout>
        </div>
      </Layout>
    );
  }
}

ResponsiveSider.propTypes = {};

const mapStateToProps = (state) => ({ 
  user: state.user,
  menuOpen: state.menu
});

const mapActionToProps = (dispatch) => bindActionCreators({ DeleteUser, MenuToggle }, dispatch);

ResponsiveSider = connect(mapStateToProps, mapActionToProps)(ResponsiveSider);

export default withRouter(ResponsiveSider);